<template>
  <div>

    <fieldset>
      <label>Site Meta Json Url</label>
      <input type="text" v-model="site_meta_json_url" />
    </fieldset>

    <a class="button" @click="getSite__clicked" style="width:200px;">Get Site</a>

    <br /><br />


    <div v-if="document_id">
        <table class="admin__table">
          <tr>
            <td style="width: 100px;">site_id</td>
            <td>{{ document_id}}</td>
          </tr>
          <tr>
            <td>domain</td>
            <td>{{domain}}</td>
          </tr>
          <tr>
            <td>domain_url</td>
            <td>{{domain_url}}</td>
          </tr>
          <tr>
            <td>myshopify_domain</td>
            <td>{{ myshopify_domain }}</td>
          </tr>
        </table>

         <br /><br />

        <a class="button" @click="addSite__clicked" style="width:200px;">Add Site</a>
    </div>
  </div>
</template>


<script>
import PotentialShopifySite from "../../../models/PotentialShopifySite";
import ShopifySite from "../../../models/ShopifySite";
import router from '../../../router/router'
import Category from "../../../models/Category";
import CategoryMapping from "../../../models/CategoryMapping";
import ShopifyProduct from "../../../models/ShopifyProduct";

export default {
  data(){
    return{
      site_meta_json_url: "https://self-portrait.com/meta.json",

      document_id: null,
      domain: "",
      myshopify_domain: "",

      site: null,
      potential_site: {}

    }
  },
  mounted(){

  },
  computed:{

  },
  methods: {
    async getSite__clicked(){
      console.log("site url", this.site_meta_json_url);
      let response = await fetch(this.site_meta_json_url).then( response => response.json());

      if(response.id > 1){
        this.domain = this.site_meta_json_url.replace("/meta.json", "")
                                              .replace("http://", "")
                                              .replace("https://", "");
        this.document_id = this.domain.replace("www.", "");
        this.myshopify_domain = response.myshopify_domain;
        this.domain_url = this.domain;


      }

      console.log("r", response);
    },

    async addSite__clicked(){

      let exists = await PotentialShopifySite.exists(this.document_id);

      if(exists){

        alert("Site already exists with document id " + this.document_id);

      } else {

        let instance = new PotentialShopifySite();
        instance.document_id = this.document_id;
        instance.domain_url = this.domain_url;
        instance.domain = this.domain;
        instance.myshopify_domain = this.myshopify_domain;

        instance.weighting = 100;
        instance.approval_state = PotentialShopifySite.ApprovalState.NOT_SET;
        instance.product_types = [];
        instance.category_mappings = [];
        instance.main_image_index = 0;
        instance.alexa_rank = 0;
        instance.platform_rank = 0;
        instance.rank = 0;
        instance.common_crawl_pagerank = 0;

        instance.shopify_id = "";
        instance.shopify_name = "";
        instance.shopify_city = "";
        instance.shopify_province = "";
        instance.shopify_country = "";
        instance.shopify_currency = "";
        instance.shopify_domain = "";
        instance.shopify_url = "";
        instance.shopify_myshopify_domain = "";
        instance.shopify_description = "";
        instance.shopify_ships_to_countries = [],
        instance.shopify_money_format = "";
        instance.shopify_published_collections_count = 0;
        instance.shopify_published_products_count = 0;
        instance.shopify_shopify_pay_enabled_card_brands = [];

        instance.name = "";
        instance.handle = "";
        instance.api_url = "";
        instance.currency_symbol = "";
        instance.shopify_site_document_id = "";
        instance.created_at = new Date();

        await instance.save();

        alert("Potential Site Added\n" + instance.document_id )
      }
    }
  }
}
</script>

